/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PickWinnerRequest,
    PickWinnerResponse,
} from '../models';

export interface LivestreamRandomPickApiControllerPickWinnerRequest {
    liveStreamId: string;
    pickWinnerRequest: PickWinnerRequest;
}

/**
 * 
 */
export class LiveStreamRandomPickApi extends runtime.BaseAPI {

    /**
     */
    async livestreamRandomPickApiControllerPickWinnerRaw(requestParameters: LivestreamRandomPickApiControllerPickWinnerRequest): Promise<runtime.ApiResponse<PickWinnerResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling livestreamRandomPickApiControllerPickWinner.');
        }

        if (requestParameters.pickWinnerRequest === null || requestParameters.pickWinnerRequest === undefined) {
            throw new runtime.RequiredError('pickWinnerRequest','Required parameter requestParameters.pickWinnerRequest was null or undefined when calling livestreamRandomPickApiControllerPickWinner.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:random-pick`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.pickWinnerRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async livestreamRandomPickApiControllerPickWinner(requestParameters: LivestreamRandomPickApiControllerPickWinnerRequest): Promise<PickWinnerResponse> {
        const response = await this.livestreamRandomPickApiControllerPickWinnerRaw(requestParameters);
        return await response.value();
    }

}
